export default __webpack_public_path__ + "img/m1.asset.1758f15d.png";